Namespace 'Common.Sessions'

class Common.Sessions.TabView extends Backbone.View
  template: JST['backbone/templates/common/tabs/tab']
  className: 'session'

  events:
    'click .tab-content': 'onClickOnTab'
    'click .close-tab': 'onClickCloseTab'
    'click .tab-clone': '_cloneSession'
    'click .tab-rename': 'renameTab'
    'click .tab-delete': 'deleteTab'
    'click .dropdown-toggle': 'setDropdownMenuPosition'

  MODAL_BUTTON_COLOR = '#DD6B55'

  initialize: ({session, sessions}) =>
    @session = session
    @sessions = sessions
    @listenTo(@session, 'change', @render)
    @

  onClickOnTab: ->
    @sessions.selectSession(@session)

  onClickCloseTab: (event) ->
    event.stopPropagation()
    if @session.isNew()
      @sessions.destroy(@session)
      return
    if @session.get('confirm_save_on_close')
      @session.set('confirm_save_on_close', false)
      @showSaveConfirmation()
      return
    @_closeSession()

  showSaveConfirmation: ->
    saveCallback = (mustBeSaved) =>
      if mustBeSaved then @_closeSession() else @sessions.destroy(@session)
    @_showConfirmationModal(
      title: I18n.t('common.session.tab.close_confirmation.title')
      confirmText: I18n.t('common.session.tab.close_confirmation.save')
      cancelText: I18n.t('common.session.tab.close_confirmation.delete')
      callback: saveCallback
    )

  _closeSession: ->
    @sessions.closeSession(@session)

  renameTab: ->
    @$el.find('.dropdown-menu').click()
    @$el.editable(@_getEditableOptions())
    @$el.editable('toggle')

  _getEditableOptions: ->
      type: 'text',
      display: @changeTitle,
      value: @session.get('name'),
      toggle: 'manual',
      title: I18n.t('customer_visual_mode.session.enter_name'),
      placement: 'bottom'

  changeTitle: (newName) =>
    @sessions.renameSession(@session, newName)

  deleteTab: ->
    @showDeleteConfirmation()

  showDeleteConfirmation: ->
    deleteCallback = (mustBeDeleted) =>
      @sessions.destroy(@session) if mustBeDeleted
    @_showConfirmationModal(
      title: I18n.t('common.session.tab.delete_confirmation.title')
      confirmText: I18n.t('common.session.tab.delete_confirmation.confirm')
      cancelText: I18n.t('common.session.tab.delete_confirmation.cancel')
      callback: deleteCallback
    )

  _showConfirmationModal: ({title, confirmText, cancelText, callback}) ->
    swal
      title: title
      type: 'warning'
      showCancelButton: true
      confirmButtonColor: MODAL_BUTTON_COLOR
      confirmButtonText: confirmText
      confirmButtonClass: 'btn-info'
      cancelButtonText: cancelText
      cancelButtonColor: MODAL_BUTTON_COLOR
      closeOnConfirm: true
      closeOnCancel: true
      customClass: 'common'
      callback

  render: =>
    @$el.html(@template(
      session: @session
      cloneLabel: I18n.t('customer_visual_mode.session.clone')
      renameLabel: I18n.t('customer_visual_mode.session.rename')
      deleteLabel: I18n.t('customer_visual_mode.session.delete')
      sessionName: @getSessionName(@session)
    ))
    @$el.toggleClass('active', @session.get('focused'))
    if @session.get('focused')
      @sessions.unselectAllExcluding(@session.get('id'))
    @

  setDropdownMenuPosition: (event) =>
    @$el.find('.dropdown-menu').css('left', "#{event.target.getBoundingClientRect().left - 45}px")

  getSessionName: (session) ->
    return session.get('name')

  _cloneSession: ->
    @session.clone()
